import { FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesFreshnessAnomaliesConfig = ({ watch }: Props) => (
  <>
    {watch('timestampColumn') && (
      <FormControls.FormText>
        Timestamp column: <b>{watch('timestampColumn')}</b>
      </FormControls.FormText>
    )}

    <FormControls.FormText>
      Detect freshness anomalies by looking at a{' '}
      <b>
        {watch('detectionPeriod')} {watch('detectionUnit')}
      </b>{' '}
      period and comparing it to the last <b>{watch('detectionDaysBack')}</b>{' '}
      days
    </FormControls.FormText>

    <SeverityRenderer severity={watch('severity')?.type || 'error'} />
  </>
);

export default TablesFreshnessAnomaliesConfig;
